import { getFormattedDateTime, getLocalizedMessage } from '@/core/shared'

export function initModificationInfoForView () {
	var $itemModifications = $('#item-modifications')
	if ($itemModifications) {
		var $additionDateInfo = $itemModifications.find('#created')
		$additionDateInfo.children('.item-mod-label').first().html(getLocalizedMessage('item.added'))
		$itemModifications.find('#creator').children('.item-mod-label').first().html(getLocalizedMessage('item.by.user'))
		var $modificationDateInfo = $itemModifications.find('#updated')
		$modificationDateInfo.children('.item-mod-label').first().html(getLocalizedMessage('item.last.modification'))
		$itemModifications.find('#updater').children('.item-mod-label').first().html(getLocalizedMessage('item.by.user'))
	}
}

export function initModificationInfoForEdit (itemData) {
	var $itemModifications = $('#item-modifications')
	if ($itemModifications) {
		var html = ''
		var modificationAttributes = ['created', 'creator', 'updated', 'updater']
		for (var i = 0; i < modificationAttributes.length; ++i) {
			if (!_.isUndefined(itemData[modificationAttributes[i]])) {
				html += '<span id="' + modificationAttributes[i] + '">' + '<span class="item-mod-label"></span>' +
					'<span class="item-mod-value">' + itemData[modificationAttributes[i]] + '</span></span>'
			}
		}
		$itemModifications.html(html)
		initModificationInfoForView()
	}
}

export function updateModificationInfo (itemData) {
	var $itemModifications = $('#item-modifications')
	if ($itemModifications) {
		if (!_.isUndefined(itemData['updated'])) {
			$itemModifications.find('#updated').children('.item-mod-value').first().html(getFormattedDateTime(new Date(parseInt(itemData['updated']))))
		}
		if (!_.isUndefined(itemData['updater'])) {
			$itemModifications.find('#updater').children('.item-mod-value').first().html(itemData['updater'])
		}
	}
}
